function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "menu"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 11,
  width: 18,
  height: 2,
  rx: 0.95,
  ry: 0.95
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 16,
  width: 18,
  height: 2,
  rx: 0.95,
  ry: 0.95
}), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 6,
  width: 18,
  height: 2,
  rx: 0.95,
  ry: 0.95
})));

function SvgIconMenuOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9Im1lbnUiPjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJyb3RhdGUoMTgwIDEyIDEyKSIgb3BhY2l0eT0iMCIvPjxyZWN0IHg9IjMiIHk9IjExIiB3aWR0aD0iMTgiIGhlaWdodD0iMiIgcng9Ii45NSIgcnk9Ii45NSIvPjxyZWN0IHg9IjMiIHk9IjE2IiB3aWR0aD0iMTgiIGhlaWdodD0iMiIgcng9Ii45NSIgcnk9Ii45NSIvPjxyZWN0IHg9IjMiIHk9IjYiIHdpZHRoPSIxOCIgaGVpZ2h0PSIyIiByeD0iLjk1IiByeT0iLjk1Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgIconMenuOutline as ReactComponent };